import React from 'react'

import { useLocaleContext } from '@src/components/locale/locale.context'
import { ECOUNTRIES } from '@src/config/localisation/locale-config.derived-constants'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { parseLocale } from '@src/utils/i18n.utils'

import ApplePayButton, { ApplePayConfig } from '../apple-pay-button/apple-pay-button.component'

import { ExpressPayConfig } from './express-pay.types'

export interface ExpressPayProps {
  config?: ExpressPayConfig
  productPrice?: number
  className?: string
  dataSelectorKey?: string
  onReady?: () => void
  enableAnimation?: boolean
}

export const useIsExpressPayEnabled = () => {
  const { locale } = useLocaleContext()
  const { country } = parseLocale(locale)
  const isUSCountry = country === ECOUNTRIES.us
  const deviceInfo = useDeviceInfo()
  return isUSCountry && deviceInfo.deviceType === DEVICE_TYPES.MOBILE
}

const ExpressPay = ({
  config,
  productPrice,
  className,
  dataSelectorKey,
  onReady,
  enableAnimation,
}: ExpressPayProps) => {
  if (!config || config.disabled) {
    return null
  }

  const applePayConfig: ApplePayConfig = {
    getCheckoutDetails: config.getCheckoutDetails,
    validateApplePayClick: config.validateClick,
    onError: config.onError,
    updateShippingAddress: config.updateShippingAddress,
    updateShippingOption: config.updateShippingOption,
    checkoutExpressUpdateDetail: config.checkoutExpressUpdateDetail,
    updateExpressCompleteDetails: config.updateExpressCompleteDetails,
    capture: config.capture,
    disableApplePayExpress: config.disabled,
  }

  return (
    <>
      <ApplePayButton
        applePayConfig={applePayConfig}
        productPrice={productPrice}
        className={className}
        dataSelectorKey={dataSelectorKey}
        onReady={onReady}
        enableAnimation={enableAnimation}
      />
    </>
  )
}

export default ExpressPay
